// Libs
import React from 'react';
import { Collapse, Icon, Card } from 'antd';

// Own Libs
import * as ui from '@digital/ui';

//Api

//Files
import { CicloOrcamentarioProjetoDadosGerais } from '@app/api/relatorioCicloorcamentario';

//Utils


interface AbaGeralRelatorioCicloOrcamentarioProps {
  cicloOrcamentarioProjetoDadosGerais: CicloOrcamentarioProjetoDadosGerais;
}

const AbaGeralRelatorioCicloOrcamentario = (props: AbaGeralRelatorioCicloOrcamentarioProps) => {
  const { Panel } = Collapse;
  const { cicloOrcamentarioProjetoDadosGerais } = props;

  const collunsAnualEPlurianual: ui.ColumnProps<any>[] = [
    {
      title: 'A',
      align: 'center',
      children: [
        {
          title: 'Orçado',
          align: 'center',
          dataIndex: 'capEx',
        },
      ],
    },
    {
      title: 'B',
      align: 'center',
      children: [
        {
          title: 'Contratado',
          align: 'center',
          dataIndex: 'contratado',
        },
      ],
    },
    {
      title: 'C',
      align: 'center',
      children: [
        {
          title: 'Executado',
          align: 'center',
          dataIndex: 'executado',
        },
      ],
    },
    {
      title: 'D',
      align: 'center',
      children: [
        {
          title: 'Requisitado',
          align: 'center',
          dataIndex: 'requisitado',
        },
      ],
    },
    {
      title: 'E = B - C + D',
      align: 'center',
      children: [
        {
          title: 'Compromissado',
          align: 'center',
          dataIndex: 'compromissado',
        },
      ],
    },
    {
      title: 'F',
      align: 'center',
      children: [
        {
          title: 'A Contratar',
          align: 'center',
          dataIndex: 'aContratar',
        },
      ],
    },
    {
      title: 'G = B + D + F',
      align: 'center',
      children: [
        {
          title: 'Forecast',
          align: 'center',
          dataIndex: 'forecast',
        },
      ],
    },
    {
      title: 'H = A - G',
      align: 'center',
      children: [
        {
          title: 'variação',
          align: 'center',
          dataIndex: 'saldoCapEx',
        },
      ],
    },
  ];

  return (
    <>
      <Collapse
        bordered={false}
        defaultActiveKey={['dadosgeraisform']}
        expandIcon={() => <Icon type="arrows-right_4" />}>
        <Panel key="dadosgeraisform" header={<span>Dados Gerais</span>} style={{ border: 0 }}>
          <ui.MasterDetailForm initialValues={cicloOrcamentarioProjetoDadosGerais}>
            <ui.FormInput label="Código" name="codigo" span={2} disabled />
            <ui.FormInput label="Nome" name="nome" span={4} disabled />
            <ui.FormInput label="Categoria" name="categoria" span={2} disabled />
            <ui.FormInput label="Diretoria" name="diretoria" span={2} disabled />
            <ui.FormInput label="Área" name="area" span={2} disabled />
            <ui.FormInput label="Departamento" name="departamento" span={2} disabled />

            <ui.FormInput label="Número TOTVS" name="totvs" span={2} disabled />
            <ui.FormInput label="RFA" name="rfa" span={2} disabled />
            <ui.FormInput label="Status RFA" name="statusRfa" span={2} disabled />

            <ui.FormInput label="Data aprovação RFA" name="dataAprovacaoRfaFormatada" span={2} disabled />

            <ui.FormTextArea label="Escopo" name="escopo" span={6} disabled rows={6} />
            <ui.FormTextArea
              label="Requisitos Legais e Ambientais"
              name="requisitosAmbientais"
              span={6}
              disabled
              rows={6}
            />
          </ui.MasterDetailForm>
        </Panel>
      </Collapse>

      <Collapse
        bordered={false}
        defaultActiveKey={['DADOSCICLOORCAMENTARIO']}
        expandIcon={() => <Icon type="arrows-right_4" />}>
        <Panel key="DADOSCICLOORCAMENTARIO" header={<span>DADOS CICLO ORÇAMENTÁRIO</span>} style={{ border: 0 }}>
          <ui.MasterDetailForm initialValues={cicloOrcamentarioProjetoDadosGerais}>
            <ui.FormInput label="TAP Atual" name="tapAtual" span={3} disabled />
            <ui.FormInput label="Previsto" name="previsto" span={3} disabled />
            <ui.FormTextArea label="Escopo TAP" name="escopoTab" span={12} disabled rows={6} />
          </ui.MasterDetailForm>
        </Panel>
      </Collapse>

      <Collapse bordered={false} defaultActiveKey={['relatorio']} expandIcon={() => <Icon type="arrows-right_4" />}>
        <Panel key="relatorio" header={<span>relatórios</span>} style={{ border: 0 }}>
          <ui.MasterDetailForm initialValues={cicloOrcamentarioProjetoDadosGerais}>
            <div className="cards-boletim-medicao">
              <ui.Row>
                <ui.Col span={2}>
                  <Card title="INÍCIO BASELINE (BL)" bordered={false}>
                    {cicloOrcamentarioProjetoDadosGerais.inicioBaseline}
                  </Card>
                </ui.Col>
                <ui.Col span={2}>
                  <Card title="TÉRMINO BASELINE (BL)" bordered={false}>
                    {cicloOrcamentarioProjetoDadosGerais.terminoBaseline}
                  </Card>
                </ui.Col>
                <ui.Col span={2}>
                  <Card title="Início real" bordered={false}>
                    {cicloOrcamentarioProjetoDadosGerais.inicioReal}
                  </Card>
                </ui.Col>
                <ui.Col span={2}>
                  <Card title="Término real" bordered={false}>
                    {cicloOrcamentarioProjetoDadosGerais.terminoReal}
                  </Card>
                </ui.Col>
                <ui.Col span={2}>
                  <Card title="Início Forecast" bordered={false}>
                    {cicloOrcamentarioProjetoDadosGerais.inicioRealForecast}
                  </Card>
                </ui.Col>
                <ui.Col span={2}>
                  <Card title="Término Forecast" bordered={false}>
                    {cicloOrcamentarioProjetoDadosGerais.terminoRealForecast}
                  </Card>
                </ui.Col>
              </ui.Row>
            </div>
            <ui.Row>
              <ui.Col>
                <fieldset>
                  <legend>PLUNIANUAL</legend>
                  <ui.Table
                    dataSource={cicloOrcamentarioProjetoDadosGerais.pluriAnual}
                    columns={collunsAnualEPlurianual}
                    pagination={false}
                  />
                </fieldset>
                <fieldset>
                  <legend>Anual</legend>
                  <ui.Table
                    dataSource={cicloOrcamentarioProjetoDadosGerais.anual}
                    columns={collunsAnualEPlurianual}
                    pagination={false}
                  />
                </fieldset>
              </ui.Col>
            </ui.Row>
          </ui.MasterDetailForm>
        </Panel>
      </Collapse>
    </>
  );
};

export default AbaGeralRelatorioCicloOrcamentario;
